import {
  FETCH_CONFIGURATIONS_SUCCESS,
  FETCH_CONFIGURATION_SUCCESS,
} from '../actions/configurationActions'

const initialState = {
  all: [],
  meta: { total: 0 },
  current: null,
}

export const configurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONFIGURATIONS_SUCCESS:
      return { ...state, all: action.entities, meta: action.meta }
    case FETCH_CONFIGURATION_SUCCESS:
      return { ...state, current: action.entity }
    default:
      return state
  }
}

export const selectConfigurationIndex = (state = { all: [] }) => {
  return state.all || []
}
export const selectConfigurationMeta = (state = { meta: { total: 0 } }) =>
  state.meta
export const selectConfiguration = (state, id) =>
  (state.all || []).find((config) => config.id === id) || state.current
